import type { OrderView } from '../../../../../services/orders/orders.service';

export type OrdersFilterKey = 'all' | 'waiting' | 'bill' | 'vip' | 'approvals' | 'preparing';

export const WAITING_THRESHOLD_MS = 60 * 60 * 1000;

export const ORDERS_FILTER_KEYS: OrdersFilterKey[] = ['all', 'waiting', 'bill', 'vip', 'approvals', 'preparing'];

export function orderMatchesFilter(order: OrderView, key: OrdersFilterKey, nowMs: number): boolean {
  switch (key) {
    case 'all':
      return true;
    case 'waiting':
      return nowMs - new Date(order.createdAt).getTime() > WAITING_THRESHOLD_MS;
    case 'bill':
      return order.isBillPrinted;
    case 'vip':
      return order.isVip;
    case 'preparing':
      return order.hasOpenKitchenItems;
    case 'approvals':
      return false;
    default:
      return false;
  }
}

export function buildOrdersFilterCounts(orders: OrderView[], nowMs: number): Record<OrdersFilterKey, number> {
  const counts = { all: 0, waiting: 0, bill: 0, vip: 0, approvals: 0, preparing: 0 } as Record<OrdersFilterKey, number>;
  for (const key of ORDERS_FILTER_KEYS) {
    counts[key] = orders.filter((order) => orderMatchesFilter(order, key, nowMs)).length;
  }
  return counts;
}

export function filterOrders(orders: OrderView[], key: OrdersFilterKey, nowMs: number): OrderView[] {
  return key === 'all' ? orders : orders.filter((order) => orderMatchesFilter(order, key, nowMs));
}